// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var React = require("react");
var Features = require("./Features.bs.js");

var container = Css.merge(/* :: */[
      Css.style(/* :: */[
            Css.background(Css.hex("dedede")),
            /* :: */[
              Css.borderRadius(Css.px(5)),
              /* :: */[
                Css.display(Css.block),
                /* :: */[
                  Css.padding(Css.em(1)),
                  /* :: */[
                    Css.marginBottom(Css.em(4)),
                    /* :: */[
                      Css.textAlign(Css.center),
                      /* :: */[
                        Css.width(Css.em(30)),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]),
      /* :: */[
        Css.style(/* :: */[
              Css.media("(min-width: 53.125em)", /* :: */[
                    Css.width(Css.em(35)),
                    /* [] */0
                  ]),
              /* [] */0
            ]),
        /* [] */0
      ]
    ]);

var title = Css.style(/* :: */[
      Css.fontSize(Css.em(1.5)),
      /* [] */0
    ]);

var Styles = /* module */[
  /* container */container,
  /* title */title
];

function Hero(Props) {
  return React.createElement("div", {
              className: container
            }, React.createElement("h1", {
                  className: title
                }, "Reason Calculator"), React.createElement(Features.make, { }));
}

var make = Hero;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
